import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import posthogPlugin from './plugins/posthog'
import KatexPlugin from './plugins/katex'
import 'katex/dist/katex.min.css'

const app = createApp(App)

if (import.meta.env.VUE_APP_POSTHOG_LOGGING_ENABLED === 'true') {
    app.use(posthogPlugin)
}

app.use(vuetify)
app.use(store)
app.use(router)
app.use(KatexPlugin)
app.mount('#app')
